import { render } from "./QuizTypeTextInput.vue?vue&type=template&id=1adade39&scoped=true"
import script from "./QuizTypeTextInput.vue?vue&type=script&lang=js"
export * from "./QuizTypeTextInput.vue?vue&type=script&lang=js"

import "./QuizTypeTextInput.vue?vue&type=style&index=0&id=1adade39&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1adade39"]])

export default __exports__